export function isNeedToShow(key: string): boolean {
  if (!window.localStorage) {
    return false;
  }

  const lastShown = Number(window.localStorage.getItem(key));
  const now = new Date().getTime();

  return !lastShown || lastShown < now;
}

export function updateShownTimestamp(key: string, interval: number) {
  if (!window.localStorage) {
    return;
  }

  const now = new Date().getTime();
  const expired = now + interval;

  window.localStorage.setItem(key, String(expired));
}
